import React from "react";

function OracleDBA_L1() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Oracle DBA – L2 </h1>
          </div>
          <div className="imgSection">
            <img
              src={require("../../../images/courses/OracleDBA_L1.jpg")}
              alt=""
            />
          </div>
          <div className="heading">
            <h1>Oracle DBA – L2 11G-12C</h1>

            <h3>Course Description –</h3>

            <h4>Prerequisites for Oracle DBA – L2 11g-12c</h4>
            <ul>
              <li>
                Participants should have finished OCP Database 11g and 12c
                Administration I course
              </li>
              <li>
                Prior Linux knowledge is not required, but will be helpful.
              </li>
            </ul>

            {/*  */}
            <h4>Audience for Oracle DBA – L2 11g-12c</h4>
            <ul>
              <li>Database Administrators</li>
              <li> PL/SQL Developer</li>
              <li>Support Engineer </li>
              <li>Technical Consultant </li>
              <li> Students who would like to become Oracle 11g and 12c OCP</li>
            </ul>

            {/*  */}

            <h4>Learn How to install Linux with relevant packages.</h4>
            <ul>
              <li> Understand HDD partitioning</li>
              <li> Primary Verses Extended Partitioning</li>
              <li> Physical Volumes / Logical Volumes / Luns</li>
            </ul>

            {/*  */}
            <h4>
              Understanding RAID / Storages / DNS / DHCP / iscsi utilities
            </h4>
            <ul>
              <li>Different levels of Raid </li>
              <li>Installation of configuration of DNS. </li>
              <li> Installation and configuration of DHCP</li>
              <li>tgtd and iscsi utilities </li>
            </ul>

            {/*  */}
            <h4>Installing Oracle DBA – L2 11g-12c Software</h4>
            <ul>
              <li>
                Install and configure 11g and 12c Oracle Database Software{" "}
              </li>
            </ul>
            {/*  */}
            <h4>Creating Oracle DBA – L2 11g-12c databases (manual)</h4>
            <ul>
              <li>Creating 11g Database and 12c Database manually</li>
            </ul>

            <h3>Course Content</h3>

            <hr style={{ border: "1px solid" }} />
{/*  */}
            <h4>Configuring Recovery Manager</h4>
            <ul>
              <li>Recovery Manager Features and Components </li>
              <li>Using a Flash Recovery Area with RMAN </li>
              <li> Configuring RMAN</li>
              <li>Control File Auto backups </li>
              <li>Retention Policies and Channel Allocation </li>
              <li>
                Using Recovery Manager to connect to a target database in
                default NOCATALOG mode{" "}
              </li>
              <li>Displaying the current RMAN configuration settings </li>
              <li>Altering the backup retention policy for a database </li>
            </ul>
{/*  */}
            <h4>Using Recovery Manager</h4>
            <ul>
              <li> RMAN Command Overview</li>
              <li>Parallelization of Backup Sets </li>
              <li> Compressed Backups</li>
              <li>Image Copy </li>
              <li> Whole Database and Incremental Backups</li>
              <li> LIST and REPORT commands</li>
              <li> Enable ARCHIVELOG mode for the database</li>
              <li>Use Recovery Manager </li>
            </ul>
{/*  */}
            <h4>Oracle Secure Backup</h4>
            <ul>
              <li>Installation and Configuration </li>
              <li> Implement the Oracle suggested strategy</li>
              <li>RMAN and Oracle Secure Backup </li>
              <li> Database and File-system files backup/restore to tape</li>
              <li>
                Using obtool and web interface to configure Oracle Secure Backup
                devices (CLI/GUI){" "}
              </li>
              <li>
                Configuring EM for Oracle Secure Backup and test backup to tape
                (EM)
              </li>
              <li> Using RMAN to back up your database to tape (CLI)</li>
              <li> Using the OB Web tool to backup file system files</li>
            </ul>

            {/*  */}
            <h4>
            Recovering from Non-critical Losses
            </h4>
            <ul>
              <li>
              Recovery of Non-Critical Files
              </li>
              <li> Creating New Temporary Tablespace</li>
              <li> Recreating Redo Log Files, Index Tablespaces, and Indexes</li>
              <li>Read-Only Tablespace Recovery </li>
              <li>Authentication Methods for Database Administrators </li>
              <li>Loss of Password Authentication File </li>
              <li>Creating a new temporary tablespace </li>
              <li>Altering the default temporary tablespace for a database </li>
            </ul>
            {/*  */}
            <h4>
            Incomplete Recovery
            </h4>
            <ul>
              <li>Recovery Steps </li>
              <li>Server and User Managed Recovery commands </li>
              <li> Recovering a Control File Autobackup</li>
              <li>Creating a New Control File </li>
              <li>Incomplete Recovery Overview </li>
              <li>Incomplete Recovery Best Practices </li>
              <li> Simplified Recovery Through RESETLOGS</li>
              <li>Point-in-time recovery using RMAN </li>
            </ul>

            {/*  */}
            <h4>
            Flashback
            </h4>
            <ul>
              <li>Flashback Database Architecture </li>
              <li> Configuring and Monitoring Flashback Database</li>
              <li>Backing Up the Flash Recovery Area </li>
              <li>Using V$FLASH_RECOVERY_AREA_USAGE </li>
              <li>Flashback Database Considerations </li>
              <li> Using the Flashback Database RMAN interface</li>
              <li>Using Flashback Database EM Interface </li>
              <li>Managing and monitoring Flashback Database operations </li>
            </ul>
            {/*  */}
            <h4>
            Dealing with Database Corruption
            </h4>
            <ul>
              <li> Block Corruption Symptoms: ORA-1578</li>
              <li>DBVERIFY Utility and the ANALYZE command </li>
              <li>Initialization parameter DB_BLOCK_CHECKING </li>
              <li>Segment Metadata Dump and Verification </li>
              <li>Using Flashback for Logical Corruption and using DBMS_REPAIR </li>
              <li>Block Media Recovery </li>
              <li>RMAN BMR Interface </li>
              <li>Dumping and Verifying Segment Metadata </li>
            </ul>
            {/*  */}

            <h4>
            Monitoring and Managing Memory
            </h4>
            <ul>
              <li>Oracle Memory Structures </li>
              <li>Automatic Shared Memory Management </li>
              <li>SGA Tuning Principles </li>
              <li>Database Control and Automatic Shared Memory Management </li>
              <li>Behavior of Auto-Tuned and Manual SGA Parameters </li>
              <li>Resizing SGA_TARGET </li>
              <li>PGA Management Resources </li>
              <li> Using the Memory Advisor</li>
            </ul>
{/*  */}
            <h4>
            Automatic Performance Management
            </h4>
            <ul>
              <li>Identifying Tunable Components </li>
              <li> Oracle Wait Events and System Statistics</li>
              <li> Troubleshooting and Tuning Views</li>
              <li> Direct Attach to SGA for Statistic Collection</li>
              <li> Advisory Framework</li>
              <li>Using the SQL Tuning and SQL Access Advisor </li>
              <li>Workload Repository </li>
            </ul>
            {/*  */}

            <h4>
            Monitoring and Managing Storage I
            </h4>
            <ul>
              <li>Database Storage Structures </li>
              <li>Space Management Overview · </li>
              <li>Oracle-Managed Files (OMF) </li>
              <li>Row Chaining and Migrating </li>
              <li>Proactive Tablespace Monitoring </li>
              <li>Managing Resumable Space Allocation </li>
              <li>SYSAUX Tablespace </li>
              <li>Monitoring table and index space usage </li>
            </ul>
            {/*  */}
          <h4>
          Monitoring and Managing Storage II
          </h4>
          <ul>
            <li>Automatic Undo Management </li>
            <li>Redo Log Files </li>
            <li>Table Types </li>
            <li> Partitioned Tables</li>
            <li> Index-Organized Tables (IOT)</li>
            <li>Managing index space with SQL </li>
            <li> Configure optimal redo log file size</li>
            <li> View “Automatic Tuning of Undo Retention”</li>
          </ul>
          {/*  */}
          <h4>
          Automatic Storage Management
          </h4>
          <ul>
            <li>ASM General Architecture and Functionalities </li>
            <li> Dynamic Performance View Additions</li>
            <li>Managing an ASM Instance </li>
            <li>ASM Disk Groups </li>
            <li> Using asmcmd Command Line</li>
            <li> Migrating Your Database to ASM Storage</li>
            <li> Creating an ASM instance in a separate Oracle Home</li>
            <li>Migrating a tablespace to use ASM storage </li>
          </ul>
          {/*  */}
          <h4>
          VLDB Support
          </h4>
          <ul>
            <li> Creating Bigfile Tablespaces</li>
            <li> Packages and data dictionary changes to support VLDB</li>
            <li>Creating and maintaining temporary tablespace groups (TTG) </li>
            <li>Partitioning and Partitioned Indexes </li>
            <li>Skipping unusable indexes </li>
            <li>Creating and using hash-partitioned global indexes </li>
            <li>DML Error Logging </li>
            <li> Interpreting Bigfile ROWIDs</li>
          </ul>
          {/*  */}
            <h4>
            Managing Resources
            </h4>
            <ul>
              <li>Database Resource Manager Concepts and Configuration </li>
              <li> Creating a New Resource Plan</li>
              <li>Active Session Pool Mechanism </li>
              <li> Maximum Estimated Execution Time</li>
              <li>Creating a Complex Plan </li>
              <li> Administering and Monitoring Resource Manager</li>
              <li>Resource Plan Directives </li>
              <li>Creating Resource Consumer Groups </li>
            </ul>
            {/*  */}
            <h4>
            Automating Tasks with the Scheduler  
            </h4>
            <ul>
              <li>Scheduler Concepts </li>
              <li>Creating a Job Class and a Window </li>
              <li> Managing Jobs, Programs, Chains, Events, Schedules, priority</li>
              <li> Viewing and Purging Job Logs</li>
              <li> Creating a program and a schedule</li>
              <li>Creating a job that uses a program and a schedule </li>
              <li>Altering the program and schedule for the job and observing the behavior change of the job </li>
              <li> Monitoring job runs</li>
            </ul>
            {/*  */}
            <h4>
            Database Security
            </h4>
            <ul>
              <li>Virtual Private Database: Overview </li>
              <li> Creating a Column-Level Policy</li>
              <li>Writing a Policy Function </li>
              <li>Policy Types </li>
              <li>Column level VPD with column masking </li>
              <li>Setting the listener password </li>
              <li> Implement VPD</li>
            </ul>
            {/*  */}
            <h4>
            Data Movement
            </h4>
            <ul>
              <li>External Tables Concepts </li>
              <li>Creating a Directory object and External Table </li>
              <li>Data Pump </li>
              <li> Transport Database</li>
              <li>RMAN CONVERT DATABASE Command </li>
              <li>Transport Tablespace </li>
              <li> Create a Directory Object</li>
              <li>Create a Temporary Table </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OracleDBA_L1;
